import {NavLink } from 'react-router-dom';
import { Outlet } from 'react-router';
import HeaderBar from '../../ClassManagement/components/headerBar';
import { useClassManagementContext } from '../../ClassManagement/utils/classManagementContext';
import { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const Index = () =>
{
  const [tabs, setTabs] = useState([ {
    id: 1,
    name: 'Sessions & Reports',
    path: 'sessionsAndReport'
  },
  {
    id: 2,
    name: 'Math Skills',
    path: 'mathSkills'
  }]);
  const {selectedCourseId, mathSkillCourses } = useClassManagementContext();

  return(
    <>
      <HeaderBar
        showCourseHelpIcon={false}
      />
      <div className="white-card mt-4">
        <div className="row message-tab align-items-center mb-3">
          <div className="col-xl-9">
            <div className="primary-tab d-md-block mb-md-0">
              <div className="btn-group">
                {tabs.map((item) => (
                  <>
                    {item.id != 2 || mathSkillCourses.includes(selectedCourseId) ? (
                      <NavLink
                        key={item.id}
                        className="btn"
                        to={item.path}
                      >
                        {' '}
                        {item.name}{' '}
                      </NavLink>
                    ):(
                      <OverlayTrigger
                        key={`tab${item.id}`}
                        placement="top"
                        overlay={
                          <Tooltip className="initial-assignment-tooltip">
                            <div>
                            Please select any math skill course to enable.
                            </div>
                          </Tooltip>
                        }>
                        <span
                          key={item.id}
                          className="btn"
                        >
                          {item.name}
                        </span>
                      </OverlayTrigger>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default Index;